"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _SNETSignupConfirmModule = _interopRequireDefault(require("./SNETSignupConfirm.module.css"));
var _components = require("../../../../components");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Info = _interopRequireDefault(require("./Info"));
var _validator = _interopRequireDefault(require("../../../../utils/validator"));
var _validationConstraints = require("./validationConstraints");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SNETSignupConfirm = props => {
  const {
    info,
    onResendOtp,
    onSubmit,
    signupAlert
  } = props;
  const [otp, setOtp] = (0, _react.useState)();
  const [validationErr, setValidationErr] = (0, _react.useState)();
  const handleSubmit = event => {
    event.preventDefault();
    setValidationErr();
    const isNotValid = (0, _validator.default)({
      otp
    }, _validationConstraints.signupConfirmConstraints);
    if (isNotValid) {
      return setValidationErr(isNotValid[0]);
    }
    onSubmit(otp);
  };
  const alert = () => ({
    type: validationErr ? _components.alertTypes.ERROR : signupAlert.type,
    message: validationErr || signupAlert.message
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETSignupConfirmModule.default.confirmOtp
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETSignupConfirmModule.default.confirmOtpWrapper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3"
  }, "Validate your email "), /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    autoComplete: "off",
    className: _SNETSignupConfirmModule.default.signupForm
  }, /*#__PURE__*/_react.default.createElement(_Info.default, info), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "outlined-confirm-otp",
    label: "Verification Code",
    type: "password",
    autoComplete: "otp",
    margin: "normal",
    variant: "outlined",
    value: otp,
    onChange: e => setOtp(e.target.value),
    autoFocus: true
  }), /*#__PURE__*/_react.default.createElement(_components.AlertBox, alert()), /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETSignupConfirmModule.default.buttonsContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    children: "Resend code",
    onClick: onResendOtp
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    children: "validate",
    onClick: handleSubmit,
    type: "submit"
  })))));
};
SNETSignupConfirm.propTypes = {
  info: _propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string
  }),
  onResendOtp: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  signupAlert: _propTypes.default.shape({
    type: _propTypes.default.string,
    message: _propTypes.default.string
  })
};
var _default = exports.default = SNETSignupConfirm;